import React from 'react';

const TeamSection = () => {
  return (
    <>
      <style jsx>{`
        .team-section {
          background: url('/images/team.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
          width: 100vw;
          min-height: 1000px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }

        .team-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0gMTAgMTAgTCA5MCA5MCBNIDY2IDEwIEwgMTAwIDQ0IE0gMTAgNTUgTCA0NCAxMDAiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjEpIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9zdmc+') repeat;
          opacity: 0.3;
          animation: backgroundPattern 20s linear infinite;
        }

        @keyframes backgroundPattern {
          0% { transform: translate(0, 0); }
          100% { transform: translate(100px, 100px); }
        }

        .team-container {
          margin: 0 auto;
          padding: 0;
          position: relative;
          z-index: 2;
          text-align: center;
          width: 100%;
        }

        .team-title-wrapper {
          background: rgba(30, 136, 229, 0.6);
          padding: 40px 20px;
          backdrop-filter: blur(10px);
          width: 100%;
        }

        .team-title {
          font-size: 2.8rem;
          font-weight: bold;
          color: white;
          margin: 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 8px rgba(0,0,0,0.5);
          line-height: 1.3;
          animation: fadeInDown 0.8s ease-out;
          margin: 0 auto;
        }

        .team-showcase {
          position: relative;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 40px;
          backdrop-filter: blur(10px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
          animation: slideInUp 0.8s ease-out 0.3s both;
          margin: 60px auto 0;
          max-width: 800px;
        }

        .team-showcase::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          animation: showcaseShine 4s ease-in-out infinite;
        }

        @keyframes showcaseShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .team-image {
          width: 100%;
          height: 300px;
          background: url('https://placehold.co/600x400@2x.png') center/cover no-repeat;
          border-radius: 15px;
          transition: all 0.3s ease;
          animation: memberPop 0.6s ease-out 0.5s both;
        }

        .team-image:hover {
          transform: scale(1.02);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
        }

        .floating-tools {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          z-index: 1;
        }

        .floating-tool {
          position: absolute;
          font-size: 2rem;
          opacity: 0.3;
          color: white;
          animation: toolFloat 8s ease-in-out infinite;
        }

        .floating-tool:nth-child(1) {
          top: 10%;
          left: 5%;
          animation-delay: 0s;
        }

        .floating-tool:nth-child(2) {
          top: 20%;
          right: 10%;
          animation-delay: 2s;
        }

        .floating-tool:nth-child(3) {
          bottom: 30%;
          left: 8%;
          animation-delay: 4s;
        }

        .floating-tool:nth-child(4) {
          bottom: 20%;
          right: 5%;
          animation-delay: 6s;
        }

        @keyframes toolFloat {
          0%, 100% { 
            transform: translate(0, 0) rotate(0deg); 
            opacity: 0.3; 
          }
          25% { 
            transform: translate(20px, -30px) rotate(5deg); 
            opacity: 0.6; 
          }
          50% { 
            transform: translate(-15px, -40px) rotate(-5deg); 
            opacity: 0.4; 
          }
          75% { 
            transform: translate(-25px, -20px) rotate(3deg); 
            opacity: 0.5; 
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(100px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes memberPop {
          from {
            opacity: 0;
            transform: scale(0) rotate(180deg);
          }
          to {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }

        @media (max-width: 1024px) {
          .team-section {
            min-height: 800px;
          }

          .team-title {
            font-size: 2.4rem;
          }

          .team-image {
            height: 250px;
          }
        }

        @media (max-width: 768px) {
          .team-section {
            min-height: 600px;
          }

          .team-title-wrapper {
            padding: 30px 15px;
          }

          .team-title {
            font-size: 2rem;
          }

          .team-showcase {
            padding: 30px 20px;
            margin: 40px auto 0;
          }

          .team-image {
            height: 200px;
          }

          .floating-tool {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .team-section {
            min-height: 500px;
          }

          .team-title-wrapper {
            padding: 25px 10px;
          }

          .team-title {
            font-size: 1.6rem;
            line-height: 1.4;
          }

          .team-showcase {
            padding: 25px 15px;
            margin: 30px auto 0;
          }

          .team-image {
            height: 150px;
          }

          .floating-tool {
            font-size: 1.3rem;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="team-section"
        role="region"
        aria-labelledby="team-heading"
        itemScope
        itemType="https://schema.org/Organization"
      >
        <div className="floating-tools" aria-hidden="true">
          <div className="floating-tool">🔧</div>
          <div className="floating-tool">🛠️</div>
          <div className="floating-tool">⚙️</div>
          <div className="floating-tool">🔩</div>
        </div>

        <div className="team-container">
          <div className="team-title-wrapper">
            <h2 
              id="team-heading"
              className="team-title"
              itemProp="description"
            >
              Des techniciens qualifiés, réactifs et engagés à prendre soin de<br />
              votre véhicule, où que vous soyez.
            </h2>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Faucon Bleu",
              "description": "Des techniciens qualifiés, réactifs et engagés à prendre soin de votre véhicule, où que vous soyez.",
              "url": "https://faucon-bleu.ma",
              "logo": "https://faucon-bleu.ma/images/logo-header.png",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Casablanca",
                "addressCountry": "MA"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+212702094593",
                "contactType": "Customer Service",
                "availableLanguage": ["French", "Arabic"]
              },
              "employee": {
                "@type": "Person",
                "jobTitle": "Technicien automobile qualifié",
                "description": "Techniciens formés et professionnels pour l'entretien automobile"
              },
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services techniques automobiles",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Service mobile",
                      "description": "Intervention à domicile par techniciens qualifiés"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Réparation en atelier",
                      "description": "Services de mécanique et carrosserie en atelier"
                    }
                  }
                ]
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default TeamSection;